import {
  SET_MEAL,
  GET_COOK_MEALS,
  ADD_REPORT,
  GET_REVIEWS,
  SET_REVIEWS,
  AddReport,
  CooksMealProps,
  UserReviews,
} from './types';

export const getMeals = (cookid: string) => ({ type: GET_COOK_MEALS, cookid });

export const setMeals = (meals: CooksMealProps[]) => ({
  type: SET_MEAL,
  meals,
});

export const addReport = (report: AddReport) => ({ type: ADD_REPORT, report });

export const getReviews = (meal: CooksMealProps[]) => ({
  type: GET_REVIEWS,
  meal,
});

export const setReviews = (reviews: UserReviews[]) => ({
  type: SET_REVIEWS,
  reviews,
});
